<template>
  <div>
    <app-cells><h1 class="title">Cancellation requests</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view  />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'HotelsCancellationsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'reservation-hotels-cancellations-active', label: 'Pending' },
        { name: 'reservation-hotels-cancellations-cancelled', label: 'Cancelled' },
        { name: 'reservation-hotels-cancellations-stopped', label: 'Stopped' },
      ],
    }
  },
}
</script>
